import { render, staticRenderFns } from "./AdsRevenue.vue?vue&type=template&id=f93dad48&scoped=true&"
import script from "./AdsRevenue.vue?vue&type=script&lang=js&"
export * from "./AdsRevenue.vue?vue&type=script&lang=js&"
import style0 from "./AdsRevenue.vue?vue&type=style&index=0&id=f93dad48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93dad48",
  null
  
)

export default component.exports